import { render } from "./Clickable.vue?vue&type=template&id=477f588c&scoped=true"
import script from "./Clickable.vue?vue&type=script&lang=js"
export * from "./Clickable.vue?vue&type=script&lang=js"

import "./Clickable.vue?vue&type=style&index=0&id=477f588c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477f588c"]])

export default __exports__